<template>
	<div>

		<div v-if="page_stage == 'bluff'" class="sub-container">
			<h1>
				<template v-if="bluff.title">
					{{ $t(bluff.title) }}
				</template>
			</h1>
			<p class="mb-3" v-if="bluff.message">
				{{ $t(bluff.message) }}
			</p>
		</div>
		<div v-else-if="page_stage == 'view'" class="main-viewer">

			<h1 class="title is-1">
				{{ $t('piterkit') }}
			</h1>
			<h3 class="subtitle is-4 mb-5">
				{{ stage.title }}
			</h3>

			<h4 class="subtitle is-5">
				{{ movie_session.title }}
			</h4>

			<template v-if="movie_session && !state_voting_closed && !state_session_stopped">

				<template v-if="!notes_read">
					<div class="subnotes" v-html="$t('viewer_instructions')"></div>

					<button class="button is-light is-outlined mt-5" @click="notes_read = true">
						{{ $t('i_read_notes') }}
					</button>
				</template>
				<template v-else>

					<template v-if="movie_session.youtube_id && player_width && player_height">
						<YouTube 
							:src="'https://youtu.be/'+movie_session.youtube_id" 
							:vars="vars"
							:width="player_width"
							:height="player_height"
							@ready="YT_onReady"
							@state-change="YT_onStateChange"
							ref="youtube_player"
						/>
						<button class="button is-light is-outlined mt-5" @click="YT_command('fullscreen')" v-if="fullscreen_button">
							{{ $t('toggle_fullscreen') }}
						</button>
					</template>

					<template v-if="movie_session.vimeo_link">
						<kit-vimeo-player 
							:video-url="movie_session.vimeo_link"
							:autoplay="true"
							:controls="false"
							class="vimeo-container"
							ref="vimeo_player"
						/>
						<button class="button is-light is-outlined mt-5 mr-4" @click="vimeo_command('fullscreen')" v-if="fullscreen_button">
							{{ $t('toggle_fullscreen') }}
						</button>

						<button class="button is-light is-outlined mt-5 mr-4" @click="vimeo_command('play')">
							{{ $t('play') }}
						</button>

						<button class="button is-light is-outlined mt-5" @click="vimeo_command('mute')">
							<template v-if="muted">
								{{ $t('set_unmute') }}
							</template>
							<template v-else>
								{{ $t('set_mute') }}
							</template>
						</button>
					</template>

				</template>

			</template>
			<p v-else>
				{{ $t('thanks_for_watching') }}
			</p>

			<div class="block mt-4" v-if="notes_read">

				<div class="subnotes" v-if="state_session_started">
					<!-- Показ пошел из вмикса -->

					<template v-if="state_session_ended">

						<div v-html="$t('session_is_ended')"></div>

						<!-- Показ закончился по времени -->
						<template v-if="!state_voting_closed">

							<!-- Голосование НЕ зыкрыто -->
							<template v-if="can_vote">
								{{ $t('remember_pincode') }}
								<router-link class="button is-fullwidth is-light is-outlined mt-3 is-large" :to="'/t/'+ticket">
									{{ $t('proceed_to_voting') }}
								</router-link>

								<p class="has-text-small mt-3">
									{{ $t('voting_button_no_action') }}
									<br>
									<code class="block">
										{{ voting_ticket.link }}
									</code>
									<br>
									{{ $t('voting_button_no_action_end') }}
								</p>
							</template>
							<template v-else>
								<div v-if="was_late && !was_absent" v-html="$t('session_is_ended_no_vote_late')"></div>
								<div v-else-if="!was_late && was_absent" v-html="$t('session_is_ended_no_vote_absent')"></div>
								<div v-else-if="was_late && was_absent" v-html="$t('session_is_ended_no_vote_late_absent')"></div>
							</template>

						</template>
						<template v-else>
							<div v-if="state_voting_closed" v-html="$t('session_voting_has_ended')"></div>
						</template>
					</template>
					<template v-else>
						<!-- Показ идет -->
						<div v-html="$t('session_roll_started')" v-if="movie_session_started_awhile"></div>
						<div v-html="$t('session_roll_will_start_soon')" v-else></div>

						<div v-html="$t('session_roll_will_start_soon_vote')" v-if="can_vote"></div>
						<div v-html="$t('session_roll_will_start_soon_no_vote')" v-else></div>
					</template>
				</div>
				<div v-else>
					<!-- Показ еще не пошел из вмикса -->
					<div v-html="$t('session_is_not_started')"></div>
					<p v-if="!past_due && !state_session_started">
						{{ $t('will_start_in') }}
						<span style="font-size: 16px; white-space: nowrap;" :class="[{ 'has-text-danger': expiring }]">
							{{ countdown }}
						</span>
					</p>
					<div v-html="$t('session_is_not_started_vote')" v-if="can_vote"></div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
import axios from 'axios'
import YouTube from 'vue3-youtube'
import KitVimeoPlayer from './KitVimeoPlayer'
import moment from 'moment'

export default{
	name: 'TicketOnlineView',
	props: {
		ticket: {
			required: true
		}
	},
	data(){
		return {
			movie_session: null,
			stage: null,
			voting_ticket: null,
			page_stage: 'prepare',
			bluff: null,
			vars: {
				autoplay: 1,
				controls: 1,
				modestbranding: 1,
				showinfo: 0,
				disablekb: 1
			},
			player_width: null,
			player_height: null,
			player_ready: false,
			notes_read: false,
			movie_session_started_awhile: false,
//			fullscreen: false,
			fullscreen_button: true,
			WATCH_DOG_TMID: null,
			muted: false,
			TMID: null,
			expiring: false,
			countdown: null
		}
	},
	components: {
		YouTube,
//		vueVimeoPlayer,
		KitVimeoPlayer
	},
	computed:{
		// those are MAIN STATE identificators!!!
		state_voting_opened(){
			return this.movie_session.voting_opened_at
		},
		state_voting_closed(){
			return this.movie_session.voting_closed_at
		},
		state_session_started(){
			return this.movie_session.started_at
		},
		state_session_ended(){
			return this.movie_session.viewing_ended_at
		},
		state_session_stopped(){
			return this.movie_session.stopped_at
		},
		can_vote(){
			return !this.voting_ticket.was_late && !this.voting_ticket.was_absent
		},
		was_late(){
			return this.voting_ticket.was_late
		},
		was_absent(){
			return this.voting_ticket.was_absent
		},
		past_due(){
			return !this.timeLeft()
		}
	},
	mounted(){
		this.prepare()

		let width = parseInt(window.innerWidth),
			paddingLeft = parseInt(window.getComputedStyle(document.getElementsByClassName('hero-body')[0], null).getPropertyValue('padding-left')),
			paddingRight = parseInt(window.getComputedStyle(document.getElementsByClassName('hero-body')[0], null).getPropertyValue('padding-right')),
			player_width = width-paddingRight-paddingLeft

		if(player_width > 1000){
			player_width = 1000
		}

		this.player_width = player_width
		this.player_height = (player_width/16)*9

		window.Echo.channel('movie-session-change-state').listen('MovieSessionChangeState', data => {

			if(this.movie_session && data.payload.movie_session && this.movie_session.id == data.payload.movie_session.id){
				// that is my session

				//this.movie_session = data.payload.movie_session

				this.movie_session.voting_opened_at = data.payload.movie_session.voting_opened_at
				this.movie_session.voting_closed_at = data.payload.movie_session.voting_closed_at
				this.movie_session.started_at = data.payload.movie_session.started_at
				this.movie_session.viewing_ended_at = data.payload.movie_session.viewing_ended_at
				this.movie_session.stopped_at = data.payload.movie_session.stopped_at

				if(data.payload.action == 'started'){
					console.log('session started in vmix, setting awhile in 20 seconds, starting watch_dog')

					setTimeout(() => {
						this.movie_session_started_awhile = true
					}, 5*1000) // timeout for streaming delay to pass

					this.setWatchDog()

				} else if(data.payload.action == 'stopped'){
					console.log('session stopped in vmix, unsetting watch dog even if it was unset earlier, push to voting - nothing to see here')

					this.unsetWatchDog()
					this.$router.replace(`/t/${this.ticket}`)

				} else if(data.payload.action == 'open'){
					console.log('voting is open, unsetting watch dog even if it was unset earlier, if stopped in vmix - push to voting')
					this.unsetWatchDog()

					if(this.state_session_stopped){
						this.$router.replace(`/t/${this.ticket}`)
					}
				} else if(data.payload.action == 'close'){
					console.log('voting closed, unsetting watch dog even if it was unset earlier, alert user, redirect to stage foyer')

					this.unsetWatchDog()

					alert(this.$t('voting_has_ended'))

					this.$router.replace(`/stage/${this.stage.id}/foyer`)
				} else if(data.payload.action == 'viewing_ended'){
					console.log('viewing ended!!! unsetting watch dog here')

					this.unsetWatchDog()
				}

			}
			// DONE HERE
		})

		window.Echo.channel(`ticket-${this.ticket}`).listen('DuplicateTicketEntrance', data => {

			let my_hash = localStorage.getItem('hash')

			if(my_hash != data.payload.entering_hash){
				this.page_stage = 'bluff'
				this.bluff = data
				alert(this.$t(this.bluff.message))
				this.unsetWatchDog()
				this.$router.replace(`/stage/${this.stage.id}/foyer`)
			} else {
				//alert('You are accessing same ticket one more time. Sure?')
			}

			console.log(data)
		})
	},
	methods: {
		unsetWatchDog(){
			clearInterval(this.WATCH_DOG_TMID)
			this.WATCH_DOG_TMID = null
		},
		setWatchDog(){
			let state = 'online',
				watch_dog_lag = 30,
				my_hash = localStorage.getItem('hash')

			setTimeout(() => {
				this.WATCH_DOG_TMID = setInterval(() => {
					let player_muted = false,
						player_paused = false,
						player_current_time = null


					if(this.$refs.vimeo_player){
						player_muted = this.$refs.vimeo_player.muted
						player_paused = this.$refs.vimeo_player.paused
						player_current_time = this.$refs.vimeo_player.currentTime
					} else {
						console.log('youtube')
					}


					axios.post(`${process.env.VUE_APP_API_LOCATION}/api/tickets/${this.ticket}/ping`, { 
						state: state, 
						hash: my_hash, 
						muted: player_muted, 
						paused: player_paused, 
						current_time: player_current_time
					}).then(r => {
						if(r.data.result == 'error'){
							if(r.data.action == 'go_to_stage_foyer'){
								this.page_stage = 'bluff'
								this.bluff = r.data
								this.unsetWatchDog()
								alert(this.$t(this.bluff.message))
								this.$router.replace(`/stage/${this.stage.id}/foyer`)
							}
						} else {
							this.movie_session.voting_opened_at = r.data.movie_session.voting_opened_at
							this.movie_session.voting_closed_at = r.data.movie_session.voting_closed_at
							this.movie_session.started_at = r.data.movie_session.started_at
							this.movie_session.viewing_ended_at = r.data.movie_session.viewing_ended_at
							this.movie_session.stopped_at = r.data.movie_session.stopped_at

							this.voting_ticket = r.data.ticket
						}
					})

				}, watch_dog_lag*1000)
			}, 10000)

		},
		YT_onReady() {
			let player_state = this.$refs.youtube_player.getPlayerState()

			//console.log('onReady player_state', player_state)

			if(player_state != 1){

				// wait for 2 seconds and play
				let INT_ID = setInterval(() => {
					// check state
					let player_state = this.$refs.youtube_player.getPlayerState()

					if(player_state != 1){
						console.log('player_state', player_state)
						this.$refs.youtube_player.playVideo()
						//console.log('check', this.$refs.youtube_player)
					} else {
						clearInterval(INT_ID)
					}
				}, 5000)

			}
			
		},
		YT_onStateChange(evt) {
			console.log("Player state changed", evt);
			console.log("Current time", evt.target.getCurrentTime())
		},
		YT_command(command){
			if(command == 'stop'){
				this.$refs.youtube_player.stopVideo()
			} else if(command == 'play'){
				this.$refs.youtube_player.playVideo()
			} else if(command == 'console'){
				console.log(this.$refs.youtube_player.PlayerState)
			}
			
		},
		vimeo_command(command){
			//console.log(this.$refs.vimeo_player)

			if(command == 'fullscreen'){
				this.$refs.vimeo_player.goFullscreen()
/*				fullscreen.toggle(this.$el.querySelector('.vimeo-container iframe'), {
					teleport: true,
					callback: (isFullscreen) => {
						this.fullscreen = isFullscreen
					},
				})*/
			} else if(command == 'play'){
				this.$refs.vimeo_player.play()
			} else if(command == 'pause'){
				this.$refs.vimeo_player.pause()
			} else if(command == 'mute'){
				if(this.muted){
					this.$refs.vimeo_player.unmute()
				} else {
					this.$refs.vimeo_player.mute()
				}
				this.muted = !this.muted
			}
		},
		makeid(length) {
			let result           = '',
				characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
				charactersLength = characters.length

			for ( var i = 0; i < length; i++ ) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result
		},
		async prepare(){
			let hash = localStorage.getItem('hash')

			if(!hash){
				hash = this.makeid(32)
				localStorage.setItem('hash', hash)
			} else {
				// we already got hash
				// 1. page reloading
				// 2. new page open on the same machine
			}

			await axios.post(`${process.env.VUE_APP_API_LOCATION}/api/tickets/${this.ticket}/view`, { hash: hash }).then(r => {
				if(r.data.result == 'ok'){
					if(r.data.proceed_to == 'view'){
						this.page_stage = 'view'
						this.movie_session = r.data.movie_session
						this.stage = r.data.stage
						this.voting_ticket = r.data.ticket

						if(r.data.movie_session.started_at){ // vmix switch to list. Means that session IS ALREADY started!!! this ticket cannot vote

							setTimeout(() => {
								this.movie_session_started_awhile = true
							}, 20*1000) // 20 seconds timeout for streaming delay to pass

							this.setWatchDog()
						} else {
							if(this.timeLeft()){
								this.startTimer()
							}
						}

					} else {
						this.page_stage = 'bluff'
						this.bluff = r.data
					}
				} else {
					this.page_stage = 'bluff'
					this.bluff = r.data
				}
			})
		},
		timeLeft(){
			var duration = moment.duration(moment(this.movie_session.start).diff(moment()));
			var seconds = duration.asSeconds();

			if(seconds < 0){
				return false
			}

			let format = 'HH:mm:ss'

			if(parseInt(seconds) > 86400){
				format = 'DD ['+this.$t('days')+'] HH:mm:ss'
			}
			this.countdown = moment.utc(seconds*1000).format(format)

			if(seconds == 120){
				this.expiring - true
			}

			return seconds
		},
		startTimer(){
			this.TMID = setInterval(() => {
				this.timeLeft()
			}, 1000)
		},
	},
}
</script>
<style>
.subnotes{
	max-width: 800px;
	margin: 0px auto
}
.subnotes p{
	margin-bottom: 10px;
}

@media (max-width: 800px) {
	.subnotes p{
		font-size: 0.9em;
	}
}
.vimeo-container{
	padding:56.25% 0 0 0;position:relative;
}
.vimeo-container iframe{
	position: absolute; top: 0px; left: 0px; width: 100%; height: 100%;
}
.main-viewer{
    max-width: 1000px;
    margin: 0 auto;
}
</style>